import src from "IMAGE";
export default { src, width: 1242, height: 240, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMklEQVR42i3KsQkAIBBD0Qxjq5V2Iopg4f4D3T9I8SAhkaSNiYGD5lzQ5XGh4rp/vDwEbqYDmIq4DX0AAAAASUVORK5CYII="};
